import { HugeiconsIcon } from '@hugeicons/react';
import { Money01Icon } from '@hugeicons/core-free-icons';
import { NumCount } from "../../components";
import { cediSign, dateToHumanFormatShort } from '../../utils/constants';

function DisburseSum({ disburseData, days }) {
    return (
        <div className='bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-xl shadow-sm p-6 flex flex-col gap-4'>
            <div className='flex items-center justify-between'>
                <div className='w-10 h-10 rounded-lg bg-emerald-50 flex items-center justify-center shrink-0'>
                    <HugeiconsIcon icon={Money01Icon} size={20} className='text-emerald-600' />
                </div>
                <span className='text-xs font-medium text-gray-400 uppercase tracking-wide'>This week</span>
            </div>

            <div>
                <p className='text-sm font-medium text-gray-500 dark:text-gray-400 mb-1'>Total Disbursed</p>
                <p className='text-3xl font-bold text-gray-900 dark:text-gray-50 tabular-nums'>
                    <NumCount symbol={cediSign} number={disburseData?.todayTotal} deci={"."} />
                </p>
            </div>

            {days?.firstDay ? (
                <p className='text-xs text-gray-400'>
                    {dateToHumanFormatShort(days?.firstDay)} → {dateToHumanFormatShort(days?.lastDay)}
                </p>
            ) : (
                <div className="h-4 w-40 shimmer rounded-md" />
            )}
        </div>
    );
}

export default DisburseSum;
